import React from 'react';
import { Link } from 'react-router-dom';

/**
 * TODO:
 * Refactor this component to be reusable. Incorrect User, notauthorized and notRegistered components are similar
 */
const NotAuthorizedPage: React.FC<{}> = () => {
    return <div className="container text-center mt-5">
    <h1 className="display-4">Unauthorized Access</h1>
    <p className="lead">You do not have permission to access this page.</p>
    <p>Please contact the administrator for assistance.</p>
    <Link to="/" >Go to login</Link>
  </div>;
  };

export default NotAuthorizedPage;